// import React, { useState, useRef, useEffect } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";
// import { FaBars } from "react-icons/fa";
// import html2canvas from "html2canvas";
// import "../App.css";

// drilldown(Highcharts);

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const sortSubcategories = (categoryData) =>
//   Object.fromEntries(Object.entries(categoryData).sort());

// Object.keys(manualData).forEach((category) => {
//   manualData[category] = sortSubcategories(manualData[category]);
// });

// const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];
// const homeNetwork = "Anthem Participating Network";

// const DrilldownChart = () => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const [isFullScreen, setIsFullScreen] = useState(false);

//   const chartContainerRef = useRef(null);

//   const toggleDropdown = () => {
//     setDropdownOpen((prev) => {
//       return !prev;
//     });
//   };
//   const handleFullScreen = () => {
//     if (chartContainerRef.current) {
//       if (document.fullscreenElement) {
//         document.exitFullscreen();
//       } else {
//         chartContainerRef.current.requestFullscreen().catch((err) => {
//           console.error("Error attempting fullscreen:", err);
//         });
//       }
//     }
//   };

//   const captureScreenshot = async () => {
//     setDropdownOpen(false);

//     const buttonElement = document.getElementById("capture-hide");
//     if (buttonElement) {
//       buttonElement.style.visibility = "hidden";
//     }

//     await new Promise((resolve) => setTimeout(resolve, 50));

//     if (chartContainerRef.current) {
//       await document.fonts.load('1em "Roboto Flex, serif !important"');
//       const canvas = await html2canvas(chartContainerRef.current, {
//         useCORS: true,
//         scale: 2,
//         backgroundColor: "#FFFFFF",

//         onclone: (clonedDoc) => {
//           clonedDoc.body.style.fontFamily = "'Roboto Flex', serif !important";
//         },
//       });

//       const image = canvas.toDataURL("image/png");
//       const link = document.createElement("a");
//       link.href = image;
//       link.download = "graph.png";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }

//     if (buttonElement) {
//       buttonElement.style.visibility = "visible";
//     }
//   };
//   useEffect(() => {
//     const checkFontLoaded = () => {
//       if (document.fonts && document.fonts.ready) {
//         document.fonts.ready.then(() => {
//           // You can now safely capture the screenshot
//         });
//       }
//     };

//     window.onload = checkFontLoaded;

//     return () => {
//       window.onload = null;
//     };
//   }, []);

//   useEffect(() => {
//     const onFullScreenChange = () => {
//       setIsFullScreen(!!document.fullscreenElement);
//     };

//     document.addEventListener("fullscreenchange", onFullScreenChange);
//     return () =>
//       document.removeEventListener("fullscreenchange", onFullScreenChange);
//   }, []);

//   const [isDrilldown, setIsDrilldown] = useState(true);
//   const [selectedCategory, setSelectedCategory] =
//     useState("Category III Codes");

//   const getChartOptions = (category, isDrilldownChart = true) => {
//     const categoryData = manualData[category];
//     const networks = [
//       ...new Set(
//         Object.values(categoryData).flatMap((prices) => Object.keys(prices))
//       ),
//     ];

//     const chartData = Object.entries(categoryData).map(([subcat, prices]) => ({
//       name: subcat,
//       y: typeof prices[homeNetwork] === "number" ? prices[homeNetwork] : null,
//       drilldown: subcat,
//       color: colorPalette[0],
//     }));

//     const drilldownSeries = Object.entries(categoryData).map(
//       ([subcat, prices]) => ({
//         name: subcat,
//         id: subcat,
//         data: networks.map((net, i) => [
//           net,
//           typeof prices[net] === "number" ? prices[net] : null,
//         ]),
//         colors: networks.map((net, i) =>
//           net === homeNetwork
//             ? colorPalette[0]
//             : colorPalette[(i + 1) % colorPalette.length]
//         ),
//       })
//     );

//     return {
//       chart: {
//         type: "column",
//         events: {
//           load() {
//             const chart = this;

//             if (!chart.customChip) {
//               chart.customChip = chart.renderer
//                 .label(
//                   "Drill to Network Comparison",
//                   chart.chartWidth - 230,
//                   0,
//                   "rect",
//                   40,

//                   40,
//                   true
//                 )
//                 .attr({
//                   fill: "#f0f0f0", // background color
//                   padding: 10,
//                   r: 4, // border radius
//                   zIndex: 10,
//                   width: 160,
//                   stroke: "#ccc", // border color
//                   "stroke-width": 0.5, // border thickness
//                   display: "flex", // flexbox for centering
//                   justifyContent: "center",
//                   alignItems: "center",
//                 })
//                 .css({
//                   color: "#333",
//                   fontSize: "12px",
//                   fontFamily: "'Roboto Flex', sans-serif",
//                   textAlign: "center",
//                   fontWeight: "500",
//                 })
//                 .add();
//             }
//           },
//           drilldown() {
//             const chart = this;
//             if (chart.customChip) {
//               chart.customChip.attr({
//                 text: "Drill to Subcategory",
//                 x: chart.chartWidth - 230,
//                 y: 0,
//               });
//             }
//           },
//           drillup() {
//             const chart = this;
//             if (chart.customChip) {
//               chart.customChip.attr({
//                 text: "Drill to Network Comparison",
//                 x: chart.chartWidth - 230,
//                 y: 0,
//               });
//             }
//           },
//           redraw() {
//             // Reposition chip on resize
//             const chart = this;
//             if (chart.customChip) {
//               chart.customChip.attr({
//                 x: chart.chartWidth - 230,
//                 y: 0,
//               });
//             }
//           },
//         },
//       },
//       title: {
//         text: category,
//       },
//       xAxis: {
//         type: "category",
//         style: {
//           fontSize: "12px",
//           fontWeight: "light",
//           fontFamily: "'Roboto Flex', serif !important",
//         },
//       },
//       yAxis: {
//         title: {
//           text: "% of Medicare",
//           style: {
//             // color: "#555555",
//             fontSize: "12px",
//             fontFamily: "'Roboto Flex', serif !important",
//             letterSpacing: "-0.75px",
//           },
//         },
//       },
//       legend: {
//         enabled: false,
//       },
//       credits: {
//         enabled: false,
//       },
//       plotOptions: {
//         series: {
//           states: {
//             hover: {
//               brightness: -0.4, // darken
//             },
//           },
//           borderWidth: 0,
//           dataLabels: {
//             enabled: true,
//             format: "{point.y:.2f}",
//             style: {
//               color: "#555555",
//               cursor: "pointer",
//               border: "none",
//               fontWeight: 500,
//               fontSize: "12px",
//               fontFamily: "'Roboto Flex', serif !important",
//               textDecoration: "none",
//             },
//           },
//         },
//       },
//       exporting: { enabled: false },
//       tooltip: {
//         headerFormat:
//           '<span style="font-size: 14px; color: #5A5A5A;  max-width: 250px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
//           '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//         pointFormat:
//           "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between'  ><div style='margin-right: 0px; width:200px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
//         shared: true,
//         backgroundColor: "rgba(255, 255, 255, 1)",
//         borderColor: "#A9A9A9",
//         borderRadius: 7,
//         animation: false,
//         hideDelay: 0,
//         style: {
//           color: "#333",
//           fontFamily: "'Roboto Flex', serif",
//           transition: "none",
//           fontSize: "12px",
//           padding: "8px",
//           shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//           zIndex: 99999,
//         },
//         shadow: true,
//         useHTML: true,
//         outside: true,
//       },
//       // tooltip: {
//       //   pointFormat: "{series.name}: <b>{point.y}%</b>",
//       // },
//       series: [
//         {
//           name: category,
//           colorByPoint: true,
//           data: chartData,
//         },
//       ],
//       drilldown: isDrilldownChart
//         ? {
//             series: drilldownSeries.map((series) => ({
//               ...series,
//               data: series.data.map(([net, value], i) => ({
//                 name: net,
//                 y: value,
//                 color: series.colors[i],
//               })),
//               // 👇 Add this block here to disable hover effect on drilldown
//               states: {
//                 hover: {
//                   enabled: false,
//                   brightness: 0,
//                 },
//               },
//             })),

//             activeAxisLabelStyle: {
//               color: "#555555",
//               cursor: "pointer",
//               fontWeight: "normal",
//               fontSize: "11px",
//               fontFamily: "'Roboto Flex', serif !important",
//               textDecoration: "none",
//             },
//             activeDataLabelStyle: {
//               color: "#555555",
//               cursor: "pointer",
//               border: "none",
//               fontWeight: 500,
//               fontSize: "12px",
//               fontFamily: "'Roboto Flex', serif !important",
//               textDecoration: "none",
//             },
//             breadcrumbs: {
//               position: {
//                 align: "left",
//                 fontFamily: "'Roboto Flex', serif !important",
//               },
//               buttonTheme: {
//                 fill: "#fff",
//                 stroke: "#ccc",
//                 style: {
//                   color: "#333",
//                 },
//               },
//             },
//           }
//         : {},
//     };
//   };

//   const [chartOptions, setChartOptions] = useState(
//     getChartOptions(selectedCategory)
//   );

//   return (
//     <div
//       className="bg-white p-4"
//       style={{ border: "none", borderRadius: "8px" }}
//     >
//       {/* <select
//         className="mb-4 p-2 border rounded"
//         value={selectedCategory}
//         onChange={(e) => {
//           setIsDrilldown((prev) => !prev);
//           setSelectedCategory(e.target.value);
//           setChartOptions(getChartOptions(e.target.value));
//         }}
//       >
//         {Object.keys(manualData).map((cat) => (
//           <option key={cat} value={cat}>
//             {cat}
//           </option>
//         ))}
//       </select> */}
//       <div className="mb-4 d-flex flex-row justify-content-left align-items-center gap-1">
//         {" "}
//         <label className="form-label">Select Category:</label>
//         <div className="dropdown">
//           <a
//             className="btn btn-secondary dropdown-toggle p-2"
//             href="#"
//             variant="primary"
//             id="dropdown-basic"
//             role="button"
//             data-bs-toggle="dropdown"
//             aria-expanded="false"
//           >
//             {selectedCategory || "Select Category"}
//           </a>

//           <ul className="dropdown-menu">
//             {Object.keys(manualData).map((cat) => (
//               <li key={cat}>
//                 <a
//                   className="dropdown-item"
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setIsDrilldown((prev) => !prev);
//                     setSelectedCategory(cat);
//                     setChartOptions(getChartOptions(cat));
//                   }}
//                 >
//                   {cat}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>

//       <div
//         className="position-relative d-flex justify-content-end "
//         style={{ marginBottom: "-40px", zIndex: "999999" }}
//       >
//         {/* Menu button */}

//         <button className="btn border p-2 " onClick={toggleDropdown}>
//           <FaBars size={20} />
//         </button>

//         {/* Dropdown Menu */}
//         {dropdownOpen && (
//           <div
//             className="position-absolute bg-white border rounded shadow p-2"
//             style={{
//               right: 0,
//               top: "110%",
//               minWidth: "180px",
//               zIndex: 10,
//             }}
//           >
//             <button className="dropdown-item p-2" onClick={captureScreenshot}>
//               Download
//             </button>
//             <button className="dropdown-item p-2" onClick={handleFullScreen}>
//               {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
//             </button>
//           </div>
//         )}
//       </div>

//       <div
//         ref={chartContainerRef}
//         className={`chart-container p-1 ${isFullScreen ? "fullscreen" : ""}`}
//       >
//         <HighchartsReact
//           key={isDrilldown}
//           highcharts={Highcharts}
//           options={chartOptions}
//         />
//       </div>
//     </div>
//   );
// };

// export default DrilldownChart;

import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ChartComponent = () => {
  // Initializing state for MPM and Category selection
  const [selectedMPM, setSelectedMPM] = useState("OPPS");
  const [selectedCategory, setSelectedCategory] = useState("");

  // Medicare data with MPM, categories, and subcategories
  const medicareData = {
    OPPS: {
      "Medicine Services and Procedures": {
        "Cardiovascular Procedures": 386.92,
      },
      "Radiology Procedures": {
        "Nuclear Medicine Procedures": 116.0,
      },
      Surgery: {
        "Surgical Procedures on the Musculoskeletal System": 8292.02,
        "Surgical Procedures on the Respiratory System": 335.48,
        "Surgical Procedures on the Cardiovascular System": 868.78,
      },
    },
    PFS: {
      "Evaluation and Management": {
        "Office or Other Outpatient Services": 3018.99,
        "Emergency Department Services": 1506.08,
      },
      "Medicine Services and Procedures": {
        "Physical Medicine and Rehabilitation Evaluations": 159.69,
        "Cardiovascular Procedures": 335.46,
        "Non-Invasive Vascular Diagnostic Studies": 100.56,
        "Neurology and Neuromuscular Procedures": 127.72,
        "Allergy and Clinical Immunology Procedures": 118.8,
      },
      "Radiology Procedures": {
        "Diagnostic Radiology (Diagnostic Imaging) Procedures": 483.49,
        "Breast, Mammography": 140.65,
      },
      Surgery: {
        "Surgical Procedures on the Musculoskeletal System": 289.31,
        "Surgical Procedures on the Cardiovascular System": 230.8,
        "Surgical Procedures on the Respiratory System": 103.2,
      },
    },
    DrugB: {
      "Chemotherapy Drugs": {
        "Chemotherapy Drugs": 434.32,
      },
      "Drugs Administered Other than Oral Method": {
        "Drugs, Administered by Injection": 828.67,
      },
    },
  };

  // Handling MPM selection change
  const handleMPMChange = (event) => {
    setSelectedMPM(event.target.value);
    setSelectedCategory(""); // Reset category on MPM change
  };

  // Handling Category selection change
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  // Get available categories based on the selected MPM
  const availableCategories = Object.keys(medicareData[selectedMPM]);

  // Set the first available category as default when none is selected
  useEffect(() => {
    if (selectedCategory === "" && availableCategories.length > 0) {
      setSelectedCategory(availableCategories[0]);
    }
  }, [selectedMPM, selectedCategory, availableCategories]);

  // Get all subcategories based on the selected category
  const availableSubcategories =
    selectedCategory && medicareData[selectedMPM][selectedCategory]
      ? medicareData[selectedMPM][selectedCategory]
      : {};

  // Highcharts configuration
  const chartOptions = {
    chart: {
      type: "column",
    },
    title: {
      text: `Medicare Weights for ${selectedCategory || "Select Category"}`,
    },
    yAxis: {
      title: {
        text: "Medicare Weight",
        style: {
          // color: "#555555",
          fontSize: "12px",
          fontFamily: "'Roboto Flex', serif !important",
          letterSpacing: "-0.75px",
        },
      },
    },
    xAxis: {
      categories: Object.keys(availableSubcategories),
    },

    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            brightness: -0.4, // darken
          },
        },
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y:.2f}",
          style: {
            color: "#555555",
            cursor: "pointer",
            border: "none",
            fontWeight: 500,
            fontSize: "12px",
            fontFamily: "'Roboto Flex', serif !important",
            textDecoration: "none",
          },
        },
      },
    },
    exporting: { enabled: false },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;  max-width: 250px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between'  ><div style='margin-right: 0px; width:200px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },

    series: [
      {
        name: selectedCategory || "Select Category",
        data: Object.values(availableSubcategories),
        color: "#c0e7e7", // custom color
      },
    ],
  };

  return (
    <div
      className="bg-white p-4"
      style={{ border: "none", borderRadius: "8px" }}
    >
      {/* <div>
        <label htmlFor="mpm-select">Select MPM: </label>
        <select id="mpm-select" value={selectedMPM} onChange={handleMPMChange}>
          <option value="OPPS">OPPS</option>
          <option value="PFS">PFS</option>
          <option value="DrugB">DrugB</option>
        </select>
      </div> */}

      {/* <div className="mb-3">
        <label htmlFor="mpm-select" className="form-label">
          Select MPM:
        </label>
        <select
          id="mpm-select"
          className="form-select"
          value={selectedMPM}
          onChange={handleMPMChange}
        >
          <option value="OPPS">OPPS</option>
          <option value="PFS">PFS</option>
          <option value="DrugB">DrugB</option>
        </select>
      </div> */}
      <div className="d-flex flex-row gap-4">
        <div className="mb-4 d-flex flex-row justify-content-left align-items-center gap-1">
          <label className="form-label">Select MPM:</label>
          <div className="dropdown">
            <a
              className="btn btn-secondary dropdown-toggle p-2"
              href="#"
              variant="primary"
              //   id="mpm-dropdown"
              id="dropdown-basic"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {selectedMPM || "Select MPM"}
            </a>

            <ul className="dropdown-menu" aria-labelledby="mpm-dropdown">
              {["OPPS", "PFS", "DrugB"].map((mpm) => (
                <li key={mpm}>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleMPMChange({ target: { value: mpm } });
                    }}
                  >
                    {mpm}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* <div>
        <label htmlFor="category-select">Select Category: </label>
        <select
          id="category-select"
          value={selectedCategory}
          onChange={handleCategoryChange}
          disabled={!selectedMPM}
        >
          <option value="">Select Category</option>
          {availableCategories.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div> */}

        <div className="mb-4 d-flex flex-row justify-content-left align-items-center gap-1">
          <label className="form-label">Select Category:</label>
          <div className="dropdown">
            <a
              className={`btn dropdown-toggle p-2 ${
                selectedMPM ? "btn-secondary" : "btn-light disabled"
              }`}
              variant="primary"
              //   id="mpm-dropdown"
              id="dropdown-basic"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => {
                if (!selectedMPM) e.preventDefault(); // Prevent opening if MPM not selected
              }}
            >
              {selectedCategory || "Select Category"}
            </a>

            <ul className="dropdown-menu" aria-labelledby="category-dropdown">
              {availableCategories.map((category) => (
                <li key={category}>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCategoryChange({ target: { value: category } });
                    }}
                  >
                    {category}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {/* <div>
        {selectedCategory && <p>Selected Category: {selectedCategory}</p>}
      </div> */}

      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default ChartComponent;
